module.exports = __webpack_public_path__ + "img/category-card-bg-6.2bcc2132.png";